function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React, { useState, useRef } from 'react';
import { string, bool } from 'prop-types';
import cn from 'classnames';
import { colors } from '../colorSwatches';
import { default as SearchInputBase } from '../textInput/styles/TextInputBase';
import Label from '../label/Label';
import IconSearch from './assets/IconSearch';
import SearchIcon from './styles/SearchIcon';
/**
 * React component rendering SearchInput
 * @function
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

function SearchInput(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      label = _ref.label,
      _ref$noLabel = _ref.noLabel,
      noLabel = _ref$noLabel === void 0 ? false : _ref$noLabel,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? true : _ref$expand,
      setWidth = _ref.setWidth,
      setName = _ref.setName,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab,
      placeHolder = _ref.placeHolder,
      restProps = _objectWithoutProperties(_ref, ["className", "label", "noLabel", "expand", "setWidth", "setName", "dataAnalyticsId", "dataAnalyticsLabel", "placeHolder"]);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var inputEl = useRef(null);

  var focus = function focus() {
    setIsFocused(true);
  };

  var blur = function blur() {
    setIsFocused(false);
  };

  var onChangeFunc = function onChangeFunc(event) {
    setInputValue(event.target.value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cn('search-input', className),
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "search-input",
    style: {
      width: expand === false && setWidth
    }
  }, noLabel === false ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, _extends({
    labelFor: setName,
    label: label
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: "wrapper-input"
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: "search-icon"
  }, /*#__PURE__*/React.createElement(IconSearch, null)), /*#__PURE__*/React.createElement(SearchInputBase, {
    name: setName,
    maxLength: "200",
    size: "20",
    title: setName,
    className: "scl-input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    onFocus: focus,
    onBlur: blur,
    autoComplete: "off",
    ref: inputEl,
    "aria-label": setName,
    style: {
      padding: '19px 19px 19px 35px',
      backgroundColor: colors.white
    },
    placeholder: placeHolder
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wrapper-input"
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: "search-icon"
  }, /*#__PURE__*/React.createElement(IconSearch, null)), /*#__PURE__*/React.createElement(SearchInputBase, {
    name: setName,
    maxLength: "200",
    size: "20",
    title: setName,
    className: "scl-input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    onFocus: focus,
    onBlur: blur,
    autoComplete: "off",
    ref: inputEl,
    "aria-label": setName,
    style: {
      padding: '19px 19px 19px 35px',
      backgroundColor: colors.white
    },
    placeholder: placeHolder
  }))));
}

SearchInput.propTypes = {
  /**
   * Set a input's name
   */
  setName: string.isRequired,

  /**
   * Define label's text.
   */
  label: string,

  /**
   * Define label's htmlFor.
   */
  htmlFor: string,

  /**
   * Define additional classNames.
   */
  className: string,

  /**
   * Define if component requires a label
   */
  noLabel: bool,

  /**
   * Define if input width is 100%.
   */
  expand: bool,

  /**
   * Set a input width (expand must be set to false).
   */
  setWidth: string,

  /**
   * Define a placeholder copy.
   */
  placeHolder: string
};
export default SearchInput;